import gql from 'graphql-tag';

export const SaveAchPaymentMutation = gql`
 mutation SaveAchPayment($achPayment: AchPaymentInput!) {
  saveAchPayment(achPayment: $achPayment) {
    id
    _ContactId
    name
    bankName
    bankAccountNumberLast4
    bankRoutingNumberLast4
    accountType
    accountPurpose
    emailAddress
    __typename
  }
}
`;

